/**
 * The main module that defines the public interface for absolute.
 */
define('absolute',['require','absolute/asyncqueue','absolute/audiomanager','absolute/button','absolute/snapshot','absolute/coords','absolute/platform','absolute/screenmetrics','absolute/digitlabel','absolute/debug','absolute/digitsprite','absolute/eventbus','absolute/gameconfig','absolute/storagemanager','absolute/spriteutils','absolute/game','absolute/gameui','absolute/textutils','absolute/togglebutton','absolute/musicmanager','absolute/progressbar','absolute/progressdial','absolute/tweenutils','absolute/screen','absolute/simplemessagebox','absolute/spritemessagebox','absolute/loader','absolute/layouthelper','absolute/draggable','absolute/analytics','absolute/dialog','absolute/shims','absolute/sprite','absolute/texture','absolute/mathutils','absolute/randomutils','absolute/pageindicator','absolute/multipagedialog','absolute/multipagegenerator','absolute/graphserializer','absolute/scrollarea','absolute/textbutton','absolute/nineslice','absolute/threeslice','absolute/messagedialog','absolute/integration','absolute/assetmap','absolute/uibuilder','absolute/stringmanager','absolute/animatedbutton','absolute/animatedtextbutton','absolute/lazyloadedsprite','absolute/utils','absolute/parallaxlayer'],function (require) {
    'use strict';

    //Return the module value.
    return {
        version: '1.0',
        AsyncQueue: require('absolute/asyncqueue'),
        AudioManager: require('absolute/audiomanager'),
        Button: require('absolute/button'),
        Snapshot: require('absolute/snapshot'),
        Coords: require('absolute/coords'),
        Platform: require('absolute/platform'),
        ScreenMetrics: require('absolute/screenmetrics'),
        DigitLabel: require('absolute/digitlabel'),
        Debug: require('absolute/debug'),
        DigitSprite: require('absolute/digitsprite'),
        EventBus: require('absolute/eventbus'),
        GameConfig: require('absolute/gameconfig'),
        StorageManager: require('absolute/storagemanager'),
        SpriteUtils: require('absolute/spriteutils'),
        Game: require('absolute/game'),
        GameUI: require('absolute/gameui'),
        TextUtils: require('absolute/textutils'),
        ToggleButton: require('absolute/togglebutton'),
        MusicManager: require('absolute/musicmanager'),
        ProgressBar: require('absolute/progressbar'),
        ProgressDial: require('absolute/progressdial'),
        TweenUtils: require('absolute/tweenutils'),
        Screen: require('absolute/screen'),
        SimpleMessageBox: require('absolute/simplemessagebox'),
        SpriteMessageBox: require('absolute/spritemessagebox'),
        Loader: require('absolute/loader'),
        LayoutHelper: require('absolute/layouthelper'),
        Draggable: require('absolute/draggable'),
        Analytics: require('absolute/analytics'),
        Dialog: require('absolute/dialog'),
        Shims: require('absolute/shims'),
        Sprite: require('absolute/sprite'),
        Texture: require('absolute/texture'),
        MathUtils: require('absolute/mathutils'),
        RandomUtils:require('absolute/randomutils'),
        PageIndicator:require('absolute/pageindicator'),
        MultiPageDialog:require('absolute/multipagedialog'),
        MultiPageGenerator:require('absolute/multipagegenerator'),
        //ParticleEmitter: require('absolute/particleemitter'),
        GraphSerializer: require('absolute/graphserializer'),
        ScrollArea: require('absolute/scrollarea'),
        TextButton: require('absolute/textbutton'),
        NineSlice: require('absolute/nineslice'),
        ThreeSlice: require('absolute/threeslice'),
        MessageDialog: require('absolute/messagedialog'),
        Integration: require('absolute/integration'),
        AssetMap: require('absolute/assetmap'),
        UIBuilder: require('absolute/uibuilder'),
        StringManager: require('absolute/stringmanager'),
        AnimatedButton: require('absolute/animatedbutton'),
        AnimatedTextButton: require('absolute/animatedtextbutton'),
        LazyLoadedSprite: require('absolute/lazyloadedsprite'),
        Utils: require('absolute/utils'),
        ParallaxLayer: require('absolute/parallaxlayer')
    };
});

